import { defer } from 'react-router-dom'
import { logger, getQueryStringParamsFromStringUrl } from '$utils'
import { isAppStateReady } from 'src/state/store'
import usePayrollStore from '../store'
import { getDateRangeFromQueryStringOrAppStore } from '../../../../common/helpers/queryString'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in PaySummary loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in PaySummary loader')

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  // A fresh period starts from the remembered expand all choice. This runs on every visit and
  // every date change, so it is the only place the expansion gets reset.
  usePayrollStore.getState().resetExpansion()

  const getPaySummaryReport = usePayrollStore
    .getState()
    .getPaySummaryReport(startDateTime, endDateTime)

  // Packages are the Shift Breakdown dialog's data, not the report's, so they stay separate
  const getPackages = usePayrollStore.getState().getPackages()

  return defer({
    data: Promise.all([getPaySummaryReport, getPackages])
      .then(() => true)
      .catch((error) => {
        logger.error('Pay Summary Promise.all error', error)
        return false
      })
      .finally(() => {
        usePayrollStore.getState().setIsLoading(false)
      }),
  })
}
